var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99694 14.666L5.82985 12.3267C5.74002 11.0691 6.73608 9.99934 7.99694 9.99934C9.2578 9.99934 10.2539 11.0691 10.164 12.3267L9.99694 14.666",
    stroke: "#E6E6F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.56239 8.80831C1.32704 7.27683 1.20937 6.5111 1.4989 5.83226C1.78844 5.15342 2.43081 4.68896 3.71555 3.76005L4.67545 3.06601C6.27365 1.91045 7.07275 1.33267 7.99479 1.33267C8.91683 1.33267 9.71593 1.91045 11.3141 3.06601L12.274 3.76005C13.5588 4.68896 14.2011 5.15342 14.4907 5.83226C14.7802 6.5111 14.6625 7.27683 14.4272 8.80831L14.2265 10.1143C13.8929 12.2853 13.7261 13.3708 12.9475 14.0184C12.1689 14.666 11.0306 14.666 8.754 14.666H7.23558C4.95901 14.666 3.82073 14.666 3.04212 14.0184C2.26352 13.3708 2.0967 12.2853 1.76308 10.1143L1.56239 8.80831Z",
    stroke: "#E6E6F5",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.c119e1f0f0040efe86af489adb5cb317.svg";
export { ForwardRef as ReactComponent };